import { useEffect } from 'react';

import { gadService, ADS } from '../../services/gad';
import { isReactSnap } from '../../utils/env';

import { GoogleAdProps } from './types';
import useStyles from './styles';

export default function GoogleAd({ id, className }: GoogleAdProps) {
  const isServer = isReactSnap();
  const styles = useStyles();

  useEffect(() => {
    if (window && !isServer && id) {
      gadService.enableAd(id);
    }
  }, []);

  if (isServer) {
    return null;
  }

  const { width, height } = ADS[id];

  return (
    <div className={className}>
      <div
        id={id}
        className={styles.ad}
        style={{ width, height, maxWidth: width, maxHeight: height }}
      ></div>
    </div>
  );
}
